<!--
    almacena archivos en el store,
    en preafiliacion y dataUser
        props: ['op', 'rules', 'label']

        30/07/2023 props agregados props: ['index','btn']

        emit => correct
-->
<template>
    <v-card class="pa-4" outlined>
        <div class="mt-1 text-body-1 font-weight-medium">{{ label }}</div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-card-text>
                <ValidationProvider :rules="rules" v-slot="v">
                    <v-file-input v-model="files" @change="cagarArchivos" @click="onClearFileInput"
                        @click:clear="onClearFileInput" clearable :error-messages="v.errors[0]" show-size
                        color="primary" counter multiple placeholder="Archivos permitidos, .jpeg, .jpg, .pdf"
                        accept=".jpg, .jpeg, .pdf">
                        <template v-slot:selection="{ index, text, item, attrs, selected }">
                            <v-chip class="pa-4" color="primary" @click:close="removeFile(index)" close dark label
                                small>
                                <v-icon class="mr-2">mdi-file-outline</v-icon>
                                {{ text }}
                            </v-chip>
                        </template>
                    </v-file-input>
                </ValidationProvider>
            </v-card-text>
            <!-- Btn para guardado-->
            <v-row v-if="btn != false">
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="invalid" @click="guardar" outlined class="pa-5 ma-1"><v-icon
                        class="mr-2">mdi-content-save-outline</v-icon>GUARDAR</v-btn>
            </v-row>
        </ValidationObserver>
    </v-card>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            files: [],
            correct: false,
        }
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated'])
    },
    methods: {
        //  modificacion archivos de preafiliacion 
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteFilesPre', 'deleteItemPre']),

        // modificacion archivos de afiliado
        ...mapActions('dataUser', ['subirArchivos', 'addFiles', 'deleteFiles', 'deleteItem']),

        cagarArchivos() {
            if (this.isAuthenticated) {
                this.addFiles({ file: this.files, op: this.op })
            } else {
                this.addFilesPre({ file: this.files, op: this.op })
            }
        },
        onClearFileInput() {
            if (this.isAuthenticated) {
                this.deleteFiles({ file: '', op: this.op })
            } else {
                this.deleteFilesPre({ file: '', op: this.op })
            }
        },
        removeFile(index) {
            if (this.isAuthenticated) {
                this.files.splice(index, 1);
                console.log(this.files)
                this.deleteItem({ index: index, op: this.op })

            } else {
                this.deleteItemPre({ file: this.files.splice(index, 1), op: this.op })
            }
        },

        archivoPermitido(archivo) {
            // archivos permitidos (jpeg/jpg/png/docX/pdf/tiff/jfif)	
            console.log("tipo Archivo -> " + archivo.type);
            //console.log("Archivo -> " + archivo.name);
            let success = true
            switch (archivo.type) {
                case "image/png":
                case "image/jpg":
                case "image/jpeg":
                case "application/pdf":
                    break;
                default:
                    /*                     msg = "Error: El tipo de Archivo NO está permitido!. Permitidos (jpeg/jpg/png/pdf)."; */
                    success = false;
            }
            return success
        },
        guardar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.$emit('isCorrectForm', { valid: true, index: this.index })
                } else {

                }
            })
        }
    },
    props: ['op', 'rules', 'label', 'index', 'btn']
}
</script>